import { FormattedMessage } from 'react-intl';
import { useInvoicesList } from '../../../hooks/InvoiceHooks';
import { ServiceProps } from '../../../pages/ServicesPage';
import { IconSize, ServiceIcon } from '../ServiceIcon';
import InvoiceContent from './InvoiceContent';

export const InvoiceList: React.FC<ServiceProps> = ({ service }) => {
  const { invoices, isLoading } = useInvoicesList();

  return (
    <div className="scrollable scroll-y bg-white h-full md:h-auto modal-profile-content py-10 px-4 md:px-6 rounded-t-3xl md:rounded-3xl">
      <div className="profile-header center flex flex-col items-center bg-white pb-4">
        {service.acf.icon && (
          <ServiceIcon
            service={service}
            size={IconSize.large}
            className="mt-9 mx-auto"
          />
        )}
        <h2 className="font-semibold text-xl mt-4 text-black">
          <FormattedMessage id="Invoices" />
        </h2>
      </div>
      {Object.keys(invoices).length > 0 ? (
        <div className="justify-start items-start">
          {Object.keys(invoices)
            .reverse()
            .map((invoicesByYear, index) => {
              return (
                <div key={index}>
                  {index !== 0 && (
                    <>
                      <span className="my-3 separator bg-grey-300"></span>
                      <h2 className="font-semibold text-base text-left mt-5 text-black">
                        {invoicesByYear}
                      </h2>
                    </>
                  )}
                  <div className={`grid grid-cols-1 gap-x-4`}>
                    {invoices[invoicesByYear].map((invoice, index) => {
                      return <InvoiceContent key={index} invoice={invoice} />;
                    })}
                  </div>
                </div>
              );
            })}
        </div>
      ) : (
        <div className="mt-2 text-center text-black">
          {isLoading ? (
            <FormattedMessage id="Loading" />
          ) : (
            <FormattedMessage id="No invoice" />
          )}
        </div>
      )}
    </div>
  );
};
export default InvoiceList;
